import LegalLayout from '../LegalLayout';

export default function Return() {
  return (
    <LegalLayout title="Политика возврата средств" updatedAt="24 апреля 2026 года">
      <p>
        Настоящая Политика регламентирует порядок возврата средств за&nbsp;подписку
        на&nbsp;сервис Resstro&nbsp;SaaS. Документ дополняет&nbsp;
        <a href="/legal/offer">публичную оферту</a> и&nbsp;является её&nbsp;неотъемлемой
        частью.
      </p>

      <h2>1. Пробный период</h2>
      <p>
        Первые 3&nbsp;(три) календарных дня доступа к&nbsp;Сервису предоставляются
        бесплатно. Списание не&nbsp;происходит, если Заказчик отключит автоматическое
        продление до&nbsp;окончания пробного периода.
      </p>

      <h2>2. Отмена подписки</h2>
      <p>
        Заказчик может в&nbsp;любой момент отключить автоматическое продление в&nbsp;
        административной панели. После окончания текущего оплаченного периода Сервис
        перестаёт списывать средства; доступ сохраняется до&nbsp;последнего оплаченного
        дня включительно.
      </p>

      <h2>3. Возврат за&nbsp;неиспользованный период</h2>
      <p>
        Услуга по&nbsp;предоставлению доступа к&nbsp;Сервису считается оказанной с&nbsp;
        момента активации подписки. Стоимость уже оплаченного, но&nbsp;неиспользованного
        периода возврату <strong>не&nbsp;подлежит</strong>, за&nbsp;исключением случаев,
        перечисленных в&nbsp;п.&nbsp;4.
      </p>

      <h2>4. Случаи возврата средств</h2>
      <p>Полный или частичный возврат производится в&nbsp;следующих случаях:</p>
      <ul>
        <li>
          <strong>Сервис недоступен по&nbsp;нашей вине более 24&nbsp;часов подряд</strong>
          : возвращается стоимость подписки за&nbsp;дни недоступности;
        </li>
        <li>
          <strong>Двойное списание или техническая ошибка биллинга</strong>:
          возвращается полная сумма ошибочного списания;
        </li>
        <li>
          <strong>Списание после отмены подписки</strong>: возвращается полная сумма;
        </li>
        <li>
          <strong>Возврат по&nbsp;инициативе Исполнителя</strong>: при прекращении
          работы Сервиса возвращается стоимость неиспользованного периода.
        </li>
      </ul>

      <h2>5. Как оформить возврат</h2>
      <ol>
        <li>
          Направьте письменное обращение на&nbsp;
          <a href="mailto:resstrosaas@mail.ru">resstrosaas@mail.ru</a> с&nbsp;темой
          «Возврат средств».
        </li>
        <li>
          Укажите: ФИО или название организации, ИНН (для юр.&nbsp;лиц), email&nbsp;учётной
          записи, дату спорного списания и&nbsp;причину возврата.
        </li>
        <li>
          Мы&nbsp;ответим в&nbsp;течение 3&nbsp;рабочих дней. При обоснованности
          требования возврат производится на&nbsp;ту&nbsp;же платёжную карту или
          расчётный счёт, с&nbsp;которых поступила оплата, в&nbsp;срок до&nbsp;10&nbsp;
          рабочих дней.
        </li>
      </ol>

      <h2>6. Возврат при безналичной оплате</h2>
      <p>
        Юридическим лицам, оплатившим подписку по&nbsp;счёту, возврат производится
        по&nbsp;банковским реквизитам, указанным в&nbsp;письме-обращении, на&nbsp;основании
        корректировочного акта.
      </p>

      <h2>7. Закон «О&nbsp;защите прав потребителей»</h2>
      <p>
        Настоящая Политика не&nbsp;ограничивает права потребителей, установленные
        Законом РФ от&nbsp;07.02.1992 №&nbsp;2300-1 «О&nbsp;защите прав потребителей»,
        в&nbsp;части, в&nbsp;которой данный закон распространяется на&nbsp;услуги
        Сервиса физическим лицам.
      </p>

      <h2>8. Контакты</h2>
      <p>
        Все вопросы по&nbsp;возвратам:{' '}
        <a href="mailto:resstrosaas@mail.ru">resstrosaas@mail.ru</a>.
      </p>
    </LegalLayout>
  );
}
